<div *ngIf="form" [formGroup]="form" class="btn-group d-flex flex-wrap" id="input-modal-size">
  <common-radio-group
    formControlName="size"
    [items]="sizesRadioItems"
    [indentation]="true"
    uncheckedButtonClass="btn-info-outline btn-tel"
    checkedButtonClass="btn-info-outline btn-tel"
  ></common-radio-group>

  <input
    name="sizeOther"
    type="number"
    formControlName="sizeOther"
    style="width:4rem;"
    placeholder="8+"
    (focus)="form.get('size').value>=8"
    [ngClass]="{'is-invalid': form.get('sizeOther').touched && form.get('sizeOther').invalid }"
    class="form-control btn-tel"
  />
  <control-messages [control]="form.get('sizeOther')"></control-messages>
</div>
